import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function LovedOneAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const navigate = useNavigate();
  const totalSteps = 1;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    } else {
      navigate('/assessment/results');
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    } else {
      navigate('/assessment');
    }
  };
  const handleSelect = (option: string) => {
    setAnswers({
      ...answers,
      [currentStep]: option
    });
  };
  const isContinueDisabled = !answers[currentStep];
  return <div className="w-full min-h-screen bg-[#f5f5f7] flex flex-col font-sans text-[#111111]" data-id="element-4077">
      {/* Top Bar */}
      <div className="w-full max-w-md mx-auto px-5 pt-4 pb-2 flex items-center justify-between z-10 relative" data-id="element-4078">
        <div className="w-10" data-id="element-4079">
          <button onClick={goToPreviousStep} className="p-2 -ml-2 rounded-full hover:bg-gray-200 transition-colors text-gray-600 border-0 bg-transparent cursor-pointer" data-id="element-4080">
            <ArrowLeftIcon size={20} data-id="element-4081" />
          </button>
        </div>
        <div className="text-sm font-medium text-gray-500" data-id="element-4082">
          Step {currentStep} of {totalSteps}
        </div>
        <div className="w-10 text-right" data-id="element-4083">
          <button onClick={() => navigate('/assessment/results')} className="text-sm font-medium text-gray-400 hover:text-gray-600 border-0 bg-transparent cursor-pointer p-0" data-id="element-4084">
            Skip
          </button>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full max-w-md mx-auto px-5 mb-4" data-id="element-4085">
        <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-4086">
          <div className="h-full bg-[#631bb7] transition-all duration-300 ease-in-out" style={{
          width: `${currentStep / totalSteps * 100}%`
        }} data-id="element-4087" />
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 w-full max-w-md mx-auto px-5 relative flex flex-col" data-id="element-4088">
        <div className="flex-1 flex flex-col" data-id="element-4089">
          {currentStep === 1 && <>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1F0648] mb-6 leading-tight" data-id="element-4090">
                What's your relationship to your Guardian?
              </h2>
              <div className="space-y-3" data-id="element-4091">
                {["They're my parent", "They're my sibling", 'Other family member'].map(option => <button key={option} onClick={() => handleSelect(option)} className={`w-full text-left p-4 rounded-2xl border-2 transition-all duration-200 cursor-pointer ${answers[currentStep] === option ? 'border-[#631bb7] bg-[#f5f0ff]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-4092">
                    <span className={`font-bold text-base ${answers[currentStep] === option ? 'text-[#631bb7]' : 'text-[#111111]'}`} data-id="element-4093">
                      {option}
                    </span>
                  </button>)}
              </div>
            </>}
        </div>

        {/* Bottom Continue Button */}
        <div className="mt-auto pt-4 pb-6 bg-[#f5f5f7] z-10 sticky bottom-0" data-id="element-4094">
          <button onClick={goToNextStep} disabled={isContinueDisabled} className={`w-full py-3.5 rounded-xl font-bold text-lg transition-all duration-200 ${!isContinueDisabled ? 'bg-[#631bb7] text-white hover:bg-[#521099] shadow-md cursor-pointer' : 'bg-[#631bb7] text-white opacity-50 cursor-not-allowed'}`} data-id="element-4095">
            Continue
          </button>
        </div>
      </div>
    </div>;
}